import $ from "jquery";

export default class FormSectionHubspot {
  $el = $("section.form-hubspot");
  $spinner = this.$el.find(".spinner");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.exampleFunction();
  }

  exampleFunction() {
    const prodApiUrl = "https://booking.rocksteadymusicschool.com/api";
    const stagingApiUrl = "https://staging.rocksteadymusicschool.com/api";
    const currentDomain = window.location.hostname;
    const isLive  = currentDomain.includes("rocksteadymusicschool.com")
    const apiUrl = isLive
    ? prodApiUrl
    : stagingApiUrl;

    let schools = [];
    let schoolName = "";
    let schoolPostcode = "";
    let schoolURN = "";

    let searchTimeout = null;

    let schoolSelected = false;
    let searching = false;

    function findSchool(schoolName) {
      searching = true;
      schoolSelected = false;

      // Fetch Schools
      $.ajax({
        url: apiUrl + "/schools/find?q=" + schoolName,
        type: "GET",
        success: function (response) {
          schools = response;
          searching = false;
          displaySchools();
          $(".schoolNameSearch .spinner").addClass("opacity-0");
        },
        error: function (error) {
          $(".schoolNameSearch .spinner").addClass("opacity-0");
          searching = false;
          console.log("Error: ", error);
        },
      });
    }

    function displayNewSchoolCheckbox() {
      $('.newSchoolSectionContainer').removeClass('hidden');
      $('.newSchoolSectionCheckbox').removeClass('hidden');
    }

    function displayNewSchoolInput() {
      $('.newSchoolSection').removeClass('hidden');
      $('.schoolNameSearch').addClass('hidden');
      $('input[name="school_name"]').removeAttr('required').addClass('hidden');
      $('.newSchoolSectionCheckbox').removeClass('mt-2');
    }

    function hideNewSchoolInput() {
      $('.newSchoolSection').addClass('hidden');
      $('.schoolNameSearch').removeClass('hidden');
      $('.newSchoolSectionCheckbox').addClass('mt-2');
      $('input[name="school_name"]').attr('required', 'required').removeClass('hidden');
    }

    $('#i_cannot_find_my_school_checkbox').on('change', function() {
      if ($(this).is(':checked')) {
        displayNewSchoolInput();
      } else {
        hideNewSchoolInput();
      }
    });

    function displaySchools() {
      // Clear Schools
      $(".schoolNameSearchContainer").html("").hide();

      // Load Schools into the DOM
      schools.forEach((school) => {
        // Build div with data
        let schoolDiv = $(
          '<div class="p-2 hover:bg-gray-100 cursor-pointer">' +
          school.name +
          "</div>"
        );

        schoolDiv.on("click", function () {
          schoolSelected = true;
          schoolURN = school.id;
          schoolName = school.name;

          // Update Form
          $(".schoolNameSearch input").val(schoolName);
          $('input[name="school_urn"]').val(schoolURN).attr("readonly", true);
          $(".schoolNameSearchContainer").html("").hide();
        });

        // Append to container
        $(".schoolNameSearchContainer").append(schoolDiv).show();
      });
    }

    function validateForm(form) {
      let isValid = true;
      $(".input-error-message").remove(); // Remove previous error messages
      $('.form-error').addClass('hidden').html(''); // Hide form error message.

      // Validate required text inputs and select fields
      $("input[required]:visible:not(.hidden), select[required]:visible:not(.hidden)").each(function () {
        let fieldError = $(this).attr("data-error")
        if ( ! fieldError ) {
          fieldError = "Please enter ";
          fieldError += $(this).attr("placeholder") || $(this).prev("label").text() || "this field";
        }
        if ($.trim($(this).val()) === "") {
          isValid = false;
          $(this).addClass('input-error');
          $(this).after(`<p class="input-error-message">${fieldError}</p>`);
        } else {
          $(this).removeClass('input-error');
        }
      });

      // Validate email format
      let email = $("input[name='email']");
      let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email.val())) {
        isValid = false;
        email.addClass('input-error');
        email.after(`<p class="input-error-message">Please enter a valid email address</p>`);
      }

      // Validate phone number (if entered, must be numeric)
      let phone = $("input[name='phone']");
      let phonePattern = /^[0-9+\-\s()]+$/;
      if (phone.val() && !phonePattern.test(phone.val())) {
        isValid = false;
        phone.addClass('input-error');
        phone.after(`<p class="input-error-message">Please enter a valid phone number</p>`);
      }

      // Ensure Privacy Policy checkbox is checked
      if (!$("#contact-by-email").is(":checked")) {
        isValid = false;
        //$("#contact-by-email").next("label").addClass('text-red-alert');
        $("#contact-by-email").parent().append(`<p class="input-error-message">You must accept the Privacy Policy</p>`);
      } else {
        //$("#contact-by-email").next("label").removeClass('text-red-alert');
      }
      return isValid;
    }

    $(document).ready(function () {
      // Remove error styling and messages on input change
      $("form").on("input change", "input, select", function () {
        $(this).removeClass('input-error');
        $(this).next(".input-error-message").remove();
      });

      $("#contact-by-email").on("change", function () {
        if ($(this).is(":checked")) {
          $(this).parent().find(".input-error-message").remove();
        }
      });
      // Hide School Name Search Container
      $(".schoolNameSearchContainer").hide();

      // Set form date min attribute
      let today = new Date().toISOString().split("T")[0];
      $("#form_date").attr("min", today);

      // Set future date 6 months from now
      let monthsinFuture = 6;
      let futureDate = new Date();
      futureDate.setMonth(futureDate.getMonth() + monthsinFuture);
      futureDate = futureDate.toISOString().split("T")[0];
      $("#form_date").attr("max", futureDate);

      // Form Submission
      $(".leadFormHubspot").submit(function (e) {
        e.preventDefault();
        console.log("Hubspot Form Submitted");
        const is_valid = validateForm($(this));

        if ( ! is_valid ) {
          return;
        }

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        var job_title_value = $('#job_title_select').find(":selected").val();
        // Build body json
        let body = {
        };

        console.log(body);

        // Grey out form during submission
        $(".leadFormHubspot").append(
          '<div class="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center"></div>'
        );

        // Submit
        $.ajax({
          url: bunkerData.ajaxUrl,
          dataType: "json",
          headers: {
            "X-WP-Nonce": bunkerData.nonce,
          },
          data: {
            action: "hubspot_form_submit",
            nonce: bunkerData.ajax_nonce,
            form_data: {
              firstname: $("input[name='firstname']").val(),
              lastname: $("input[name='lastname']").val(),
              email: $("input[name='email']").val(),
              phone: $("input[name='phone']").val(),
              school_name: $("input[name='school_name']").val(),
              school_urn: $("input[name='school_urn']").val(),
              school_postcode: $("input[name='school_postcode']").val(),
              job_title: job_title_value,
              message: $("textarea[name='message']").val(),
              new_school_name: $("input[name='new_school_name']").val(),
              new_school_postcode: $("input[name='new_school_postcode']").val(),
              i_cannot_find_my_school_checkbox: $("#i_cannot_find_my_school_checkbox").is(":checked"),
          }},
          method: "POST",
          success: function (response) {
            console.log("Form Submitted: ", response);
            $(".leadFormHubspot").html(
              '<div class="text-center text-white text-2xl">Thank you for registering your interest. We will be in touch soon.</div>'
            );
              // Add scroll to the success message.
              $("html, body").animate(
                {
                  scrollTop: $(".leadFormHubspot").offset().top - 300,
                },
                1000
              );
          },
          error: function (jXHR, textStatus, errorThrown) {
              console.log("Error: ", errorThrown);
              console.log("textStatus: ", textStatus);
              const errors = jXHR.responseJSON.errors;
              console.log('Errors: ', errors);
              var error = '';
              if ( errors ) {
                error = errors.join('<br/>');
              }
              if ( error.toLowerCase().includes('urn') || error.toLowerCase().includes('school') ) {
                $('input[name="school_name"]').addClass('input-error');
                $('input[name="school_name"]').after(`<p class="input-error-message">Please select a school from the list</p>`);
              }
              $(".form-error").removeClass("hidden").html('Please correct the errors below.');
              $('#form-loading').remove();
              // Add scroll to the fail message.
              $("html, body").animate(
                {
                  scrollTop: $(".form-error").offset().top - 300,
                },
                1000
              );
            },
        });

        // Log Form Data for Debugging
        // console.log('Form Data: ', body);
      });

      // School Name Search
      $(".schoolNameSearch input").on("keyup", function () {
        // Clear Timeout
        clearTimeout(searchTimeout);

        schoolName = $(this).val();

        // Set Timeout to search after 500ms of idle to give user time to type
        searchTimeout = setTimeout(function () {
          $(".schoolNameSearch .spinner").removeClass("opacity-0");

          if (schoolName.length > 2 && !searching) {
            findSchool(schoolName);
          } else {
            // clear schools
            $(".schoolNameSearchContainer").html("").hide();
          }
        }, 500);
      });

      // Off Focus, hide school search container
      $(".schoolNameSearch input").on("focusout", function () {
        setTimeout(() => {
          if (!schoolSelected) {
            $(".schoolNameSearchContainer").hide();
          }
        }, 200);
      });

      // On Focus, show school search container
      $(".schoolNameSearch input").on("focus", function () {
        if (schools.length > 0 && !searching && !schoolSelected) {
          $(".schoolNameSearchContainer").show();
        }
      });
    });
  }
}
